import c3 from "c3";
import ChartColors from "../../../../../../utils/ChartColors";
import { sort } from "../../../../../../utils/utils";

export const drawGraph = (id, yAxisLabel, jsonData) => {
  const config = {
    bindto: `#${id}`,
    data: {
      type: "bar",
      json: sort(jsonData, (item) => item.name),
      keys: {
        x: "name",
        value: sort(Object.keys(jsonData[0]).filter((key) => key !== "name")),
      },
    },
    axis: {
      x: { type: "category" },
      y: {
        label: { text: yAxisLabel, position: "outer-middle" },
        min: 5,
        max: 100,
        tick: {
          values: [0, 20, 40, 60, 80, 100],
          format: function (d) {
            return d + "%";
          },
        },
      },
    },
    padding: { bottom: 25, left: 65 },
    color: { pattern: ChartColors },
    legend: { show: false },
    size: { height: 240 },
    zoom: { enabled: true },
    tooltip: {
      order: function (data1, data2) {
        return sort([data1, data2], (d) => d.name);
      },
    },
  };
  c3.generate(config);
};
